import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // Soft study rug grounding the hall (clear of the south door gap x630..750)
  place(ctx, f.rug(art, 200, 240), 690, 220);

  // 4 scribe desks (the WORK seats): desk just north of each anchor, stool on the anchor
  const desks = [
    [630, 175],
    [750, 175],
    [630, 320],
    [750, 320],
  ] as const;
  for (const [ax, ay] of desks) {
    place(ctx, kit.scribeDesk(art), ax, ay - 22);
    place(ctx, kit.woodStool(art), ax, ay);
  }

  // North wall: scroll shelves flanking the lectern spot (lectern drawn separately at 690,95)
  place(ctx, kit.scrollShelf(art, 64, 80), 610, 74);
  place(ctx, kit.scrollShelf(art, 64, 80), 770, 74);

  // West wall library bookcase, facing into the room
  place(ctx, kit.bookcase(art, 120), 588, 260);

  // Overhead chandelier — calm candlelight pool over the centre
  place(ctx, kit.chandelier(art), 690, 250);

  // East wall torch for warm reading light
  place(ctx, kit.wallTorch(art), 792, 140);

  // A touch of green so no corner reads as cold stone
  place(ctx, f.plant(art, 'fern'), 596, 360);
};

export default decorate;
